import React, {Component} from "react";
import {withRouter, RouteComponentProps, Link} from "react-router-dom";
import {ActionCreator} from "../../../../actions/actions";
import {connect} from "react-redux";
import * as Yup from "yup";

import {HallsActionCreators} from "../../actions/actionCreators";
import {hallsStoreSelectors} from "../../store/store";
import {configurationsAPI} from "../../../configurations/api/api";

import {ReturnTo} from "../../../../utils/ReturnTo/ReturnTo.component";
import {
    checkPermission
} from "../../../../utils/Authorization/authorization";
import {Dialog} from "../../../../utils/Dialog/Dialog.component";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {FormGridField} from "../../../../utils/forms/components/FormGrid";
import Form from "../../../../utils/forms/components/Form";

import {homeStoreSelectors} from "../../../home/store/store";
import {User} from "../../../auth/reducers/users.reducer";

import {
    HallServer
} from "../../reducers/inspectingHall.reducer";
import {ConfigVersion} from "./../../../configurations/reducers/configurationsList.reducer";
import {HallBaseConfig} from "../../reducers/hallsList.reducer";
import {CreationModes} from "../../reducers/creationMode.reducer";

import {formatDateText} from "../../../../utils/utils";

import LicenseRequest from "./LicenseRequest/LicenseRequest.component";
import UploadConfiguration from "./UploadConfiguration/UploadConfiguration.component";
import ActivityFeed from "./ActivityFeed/ActivityFeed.component";
import SystemSpec from "./SystemSpec/SystemSpec.component";
import SystemSpecHistory from "./SystemSpecHistory/SystemSpecHistory.component";
import ConfigurationsCompare from "./ConfigurationsCompare/ConfigurationsCompare.component";
import Drawer from "../../../../utils/Drawer/Drawer.component";
import SystemSpecDetail from "./SystemSpecDetail/SystemSpecDetail.component";
import Machines from "./Machines/Machines.component";

import "./ServerPage.component.scss";
import RemoteUpdateOptions, {
    getRemoteUpdateIncludes,
    prepareRemoteRTPProfiles,
    supportsRemoteRTPProfileUpdate,
    supportsRemoteGameLogoUpdate
} from "../RemoteUpdateOptions/RemoteUpdateOptions.component";
import {GameRTPProfilePayload} from "../../../configurations/components/Utils/rtp-profiles";

export interface ServerPageProps extends RouteComponentProps {
    getHall: ActionCreator;
    inspectingHall: HallBaseConfig;
    getConfigurationsList: ActionCreator;
    historyLoading: boolean;
    inspectingServer: HallServer;
    inspectingServerConfigurationsListLoading: boolean;
    inspectingServerConfigurationsList: ConfigVersion[];
    getServer: ActionCreator;
    cleanInspectingServer: ActionCreator;
    updateCreationMode: ActionCreator;
    creationMode: string | null;
    clearCompareConfigs: ActionCreator;
    getServerLicenseState: ActionCreator;
    userInfo: User;
    uploadConfigurationRemotely: ActionCreator;
}

interface ServerPageState {
    selectedForComparison: number[];
    isCompareModeActive: boolean;
    specsDialog: boolean;
    selectedSpec: {};
    downloadDialog: boolean;
    selectedUpdateTime: string;
    selectedUpdateTimeValid: boolean;
    selectedConfig: number;
    selectedVersion: number;
    errorServer: boolean;
    inspectingServer: HallServer;
    confirmUploadRemotelyDialog: boolean;
    uploadRemotelyDialog: boolean;
    includeServerConfig: boolean;
    includeGameLogos: boolean;
    gameRTPProfiles: GameRTPProfilePayload[];
    downloadingConfiguration: boolean;
}

const sessionTimeSchema = Yup.string()
    .required("Field is required.")
    .matches(
        new RegExp(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/),
        `Format must match YYYY-MM-DD MM:SS (24H).`
    );

const sessionTimeFormFields: FormGridField[] = [
    {
        name: "update_time",
        fieldType: "date",
        fieldOptions: {
            id: "update_time",
            inputType: "date",
            label: "Update Time",
            placeholder: "YYYY-MM-DD HH:MM",
            showtime: true,
            minutesinterval: 5
        },
        validation: sessionTimeSchema,
        columnClass: "fixed-size",
        formSpacing: false
    }
];

class ServerPage extends Component<ServerPageProps, ServerPageState> {
    constructor(props: ServerPageProps) {
        super(props);

        this.state = {
            selectedForComparison: [],
            isCompareModeActive: false,
            specsDialog: false,
            downloadDialog: false,
            selectedSpec: null,
            selectedUpdateTime: undefined,
            selectedUpdateTimeValid: false,
            selectedConfig: undefined,
            selectedVersion: undefined,
            errorServer: false,
            inspectingServer: undefined,
            confirmUploadRemotelyDialog: false,
            uploadRemotelyDialog: false,
            includeServerConfig: true,
            includeGameLogos: true,
            gameRTPProfiles: [],
            downloadingConfiguration: false
        };
        this.props.cleanInspectingServer();
    }

    componentDidMount() {
        this.props.getHall({
            hallId: this.props.match.params["hallId"]
        });

        this.props.getServer({
            serverId: this.props.match.params["serverId"]
        });

        if (
            checkPermission("upload_seed") ||
            checkPermission("manage_licensing") ||
            checkPermission("download_license") ||
            checkPermission("view_license")
        ) {
            this.props.getServerLicenseState({
                serverId: Number(this.props.match.params["serverId"])
            });
        }

        if (checkPermission("list_configurations")) {
            this.props.getConfigurationsList({
                serverId: Number(this.props.match.params["serverId"])
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.inspectingServerConfigurationsListLoading && nextProps.inspectingServer && nextProps.inspectingServer.hall_id != nextProps.match.params["hallId"]) {
            this.setState({errorServer: true})
        }
        if (!nextProps.inspectingServerConfigurationsListLoading && nextProps.inspectingServer !== this.state.inspectingServer) {
            this.setState({inspectingServer: nextProps.inspectingServer})
        }
    }

    downloadWithUpdateTime = () => {
        this.setState({
            downloadDialog: true,
            selectedUpdateTime: undefined,
            selectedUpdateTimeValid: false,
            selectedConfig: undefined,
            selectedVersion: undefined
        });
    };

    download = (config, version, updateTime) => {
        this.setState({downloadingConfiguration: true});

        configurationsAPI.downloadConfiguration({
            server: this.props.inspectingServer.id,
            serverName: this.props.inspectingServer.name,
            configVersion: version,
            config,
            updateTime
        }).then(
            () => this.setState({downloadingConfiguration: false}),
            () => this.setState({downloadingConfiguration: false})
        );
    };

    submitDownloadDialog = () => {
        this.download(
            this.state.selectedConfig,
            this.state.selectedVersion,
            this.state.selectedUpdateTime
        );

        this.setState({
            downloadDialog: false,
            selectedUpdateTime: undefined,
            selectedUpdateTimeValid: false,
            selectedConfig: undefined,
            selectedVersion: undefined
        });
    };

    toogleConfCompare = (config, value) => {
        const isSelected = this.state.selectedForComparison.includes(config);
        if (this.state.selectedForComparison.length <= 2) {
            if (!isSelected && value === true) {
                this.setState({
                    selectedForComparison: [
                        ...this.state.selectedForComparison,
                        config
                    ]
                });
            } else if (isSelected && value === false) {
                let newSelected = [...this.state.selectedForComparison];
                const index = newSelected.indexOf(config);
                newSelected.splice(index, 1);
                this.setState({
                    selectedForComparison: newSelected
                });
            }
        } else {
            if (!isSelected && value === true) {
                let newSelected = [...this.state.selectedForComparison];
                newSelected.splice(newSelected.length - 1, 1);
                this.setState({
                    selectedForComparison: [...newSelected, config]
                });
            } else if (isSelected && value === false) {
                let newSelected = [...this.state.selectedForComparison];
                const index = newSelected.indexOf(config);
                newSelected.splice(index, 1);
                this.setState({
                    selectedForComparison: newSelected
                });
            }
        }
    };

    deselectAllToCompare = () => {
        this.setState({
            selectedForComparison: []
        });
    };

    onCompareClose = () => {
        this.props.clearCompareConfigs();
        this.setState({
            selectedForComparison: [],
            isCompareModeActive: false
        });
    };

    closeSpecDialog = () => {
        this.setState({
            selectedSpec: null,
            specsDialog: false
        });
    };

    showSpecDialog = selectedSpec => {
        this.setState({
            selectedSpec,
            specsDialog: true
        });
    };

    openCompareMode = () => {
        this.setState({
            isCompareModeActive: true
        });
    };

    triggerConfUpload = () => {
        this.props.updateCreationMode(CreationModes.UPLOAD_CONFIG);
    };

    closeConfUpload = () => {
        this.props.updateCreationMode(null);
    };

    refreshServer = () => {
        this.props.getServer({
            serverId: Number(this.props.match.params["serverId"])
        });
    };

    closeDownloadDialog = () => {
        this.setState({
            downloadDialog: false,
            selectedUpdateTime: undefined,
            selectedUpdateTimeValid: false,
            selectedConfig: undefined,
            selectedVersion: undefined
        });
    };

    closeConfirmUploadRemotelyDialog = () => {
        this.setState({
            confirmUploadRemotelyDialog: false,
            uploadRemotelyDialog: false,
            selectedUpdateTime: undefined,
            selectedUpdateTimeValid: false
        })
    }
    openConfirmUploadRemotelyDialog = (
        profiles?: GameRTPProfilePayload[]
    ) => {
        const supportsGameLogos = supportsRemoteGameLogoUpdate(
            this.props.inspectingServer &&
                this.props.inspectingServer.system_server_version
        );
        const supportsRTPProfiles = supportsRemoteRTPProfileUpdate(
            this.props.inspectingServer &&
                this.props.inspectingServer.system_server_version
        );
        const gameRTPProfiles = prepareRemoteRTPProfiles(
            Array.isArray(profiles) ? profiles : this.state.gameRTPProfiles
        );
        this.setState({
            confirmUploadRemotelyDialog: true,
            uploadRemotelyDialog: false,
            includeServerConfig: true,
            includeGameLogos: supportsGameLogos,
            gameRTPProfiles: supportsRTPProfiles ? gameRTPProfiles : []
        })
    }

    uploadRemotely = () => {
        const {
            selectedUpdateTime,
            includeServerConfig,
            includeGameLogos
        } = this.state;
        const includes = getRemoteUpdateIncludes(
            this.props.inspectingServer &&
                this.props.inspectingServer.system_server_version,
            includeServerConfig,
            includeGameLogos,
            this.state.gameRTPProfiles
        );

        this.closeConfirmUploadRemotelyDialog()
        this.props.uploadConfigurationRemotely({
            serverId: Number(this.props.match.params["serverId"]),
            update_time: selectedUpdateTime,
            ...includes
        })
    }

    render() {
        const supportsGameLogoUpdate = supportsRemoteGameLogoUpdate(
            this.props.inspectingServer &&
                this.props.inspectingServer.system_server_version
        );
        const hasRemoteRTPProfiles =
            supportsRemoteRTPProfileUpdate(
                this.props.inspectingServer &&
                    this.props.inspectingServer.system_server_version
            ) && this.state.gameRTPProfiles.length > 0;
        const supportsRemoteUpdateOptions =
            supportsGameLogoUpdate || hasRemoteRTPProfiles;

        return (
            <div className="server-page">
                {this.state.downloadingConfiguration && (
                    <div
                        className="building-server-configuration"
                        role="status"
                        aria-live="polite"
                    >
                        <Components.LoadingRipple width={100} height={100}/>
                        <p>Building Server Configuration</p>
                    </div>
                )}
                {this.state.errorServer &&
                    <div className="row error-server">
                        Server does not exist in the selected hall.
                    </div>
                }
                {!this.state.errorServer &&
                    this.props.inspectingHall &&
                    this.state.inspectingServer && <div
                        className="container"
                        style={{
                            height: this.state.isCompareModeActive ? 0 : "auto",
                            overflow: this.state.isCompareModeActive
                                ? "hidden"
                                : "initial"
                        }}
                    >
                        <div className="row">
                            <div className="col-12">
                                <div className="heading-container">
                                    <ReturnTo
                                        to={[
                                            "/halls/",
                                            `/halls/${this.props.match.params["hallId"]}`,
                                            ""
                                        ]}
                                        label={[
                                            "Halls",
                                            this.props.inspectingHall
                                                ? this.props.inspectingHall.name
                                                : "",
                                            this.state.inspectingServer
                                                ? this.state.inspectingServer.name
                                                : ""
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row server-detail-row">
                            <div>
                                <div className="server-actions">
                                    {checkPermission("list_configurations") && (
                                        <div className="panel-container-configs">
                                            <h1>Server configurations</h1>
                                            <div className="config-list">
                                                {this.props
                                                    .inspectingServerConfigurationsListLoading && (
                                                    <div className="loading">
                                                        <Components.LoadingRipple
                                                            height={100}
                                                            width={100}
                                                        />
                                                    </div>
                                                )}
                                                {!this.props
                                                        .inspectingServerConfigurationsListLoading &&
                                                    this.props.inspectingHall &&
                                                    this.state.inspectingServer && (
                                                        <div>
                                                            {this.props.inspectingServerConfigurationsList.map(
                                                                (config, index) => {
                                                                    const selected =
                                                                        this.state.selectedForComparison.includes(
                                                                            config.id
                                                                        );
                                                                    const isLast =
                                                                        index ==
                                                                        this.props
                                                                            .inspectingServerConfigurationsList
                                                                            .length -
                                                                        1;
                                                                    return (
                                                                        <div
                                                                            className={`edit-config background-debug-off 
                                                                        ${
                                                                                this.state.inspectingServer && this.state.inspectingServer.debug_mode && "background-debug-anima"
                                                                            }
                                                                        ${
                                                                                selected ? "selected" : ""
                                                                            }`}
                                                                            key={
                                                                                config.id
                                                                            }
                                                                        >
                                                                            {checkPermission("view_configs") ?
                                                                                (<Link
                                                                                    to={`/configurations/${
                                                                                        checkPermission(
                                                                                            "create_configs"
                                                                                        ) &&
                                                                                        isLast
                                                                                            ? "new"
                                                                                            : "detail"
                                                                                    }/${
                                                                                        this
                                                                                            .props
                                                                                            .inspectingHall
                                                                                            .id
                                                                                    }/${
                                                                                        this
                                                                                            .state
                                                                                            .inspectingServer
                                                                                            .id
                                                                                    }/${
                                                                                        config.id
                                                                                    }`}
                                                                                >
                                                                                    <p>V{config.version}</p>
                                                                                    <span>
                                                                                    {formatDateText(
                                                                                        config.created_on, "short", true, true, true
                                                                                    )}
                                                                                </span>
                                                                                    {isLast &&
                                                                                        <div>
                                                                                            {checkPermission(
                                                                                                    "create_configs"
                                                                                                ) &&
                                                                                                <div
                                                                                                    className="icon-edit">
                                                                                                    <div
                                                                                                        className="tooltip-icon">
                                                                                                    <span
                                                                                                        className="tooltip-text">Edit</span>
                                                                                                        <i className="icon-pencil-alt-light"/>
                                                                                                    </div>
                                                                                                </div>
                                                                                            }
                                                                                            <div
                                                                                                className="icon-view">
                                                                                                <Link
                                                                                                    to={`/configurations/detail/${
                                                                                                        this.props.inspectingHall.id}/${
                                                                                                        this.state.inspectingServer.id}/${
                                                                                                        config.id
                                                                                                    }`}
                                                                                                    className=" tooltip-icon">
                                                                                                            <span
                                                                                                                className="tooltip-text">Details</span>
                                                                                                    <i className="icon-eye-light"/>
                                                                                                </Link>
                                                                                            </div>
                                                                                        </div>}
                                                                                </Link>) :
                                                                                <div className="server-info">
                                                                                    <p>V{config.version}</p>
                                                                                    <span>
                                                                                            {formatDateText(
                                                                                                config.created_on, "short", true, true, true
                                                                                            )}
                                                                                    </span>
                                                                                </div>
                                                                            }
                                                                            <div className="config-footer">
                                                                                <div className="config-compare">
                                                                                    {checkPermission(
                                                                                        "view_configs"
                                                                                    ) && (
                                                                                        <Components.Checkbox
                                                                                            key={`${config.id}-${selected}`}
                                                                                            checked={
                                                                                                selected
                                                                                            }
                                                                                            onChange={value =>
                                                                                                this.toogleConfCompare(
                                                                                                    config.id,
                                                                                                    value
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Compare
                                                                                        </Components.Checkbox>
                                                                                    )}
                                                                                </div>
                                                                                {this.state.inspectingServer.is_online &&
                                                                                    this.state.inspectingServer.latest_config_id &&
                                                                                    checkPermission("upload_configuration_remotely") &&
                                                                                    isLast && (
                                                                                        <div
                                                                                            className="icon-upload-remotely tooltip-icon"
                                                                                            onClick={() => {
                                                                                                if (
                                                                                                    config.auto_session_enabled ==
                                                                                                    "auto"
                                                                                                ) {
                                                                                                    this.setState({
                                                                                                        uploadRemotelyDialog: true,
                                                                                                        gameRTPProfiles: prepareRemoteRTPProfiles(
                                                                                                            config.game_rtp_profiles
                                                                                                        )
                                                                                                    })
                                                                                                } else
                                                                                                    this.openConfirmUploadRemotelyDialog(
                                                                                                        config.game_rtp_profiles
                                                                                                    )
                                                                                            }}>
                                                                                        <span className="tooltip-text">
                                                                                            Update Remotely
                                                                                        </span>
                                                                                            <i className="icon-cloud-upload"/>
                                                                                        </div>
                                                                                    )}
                                                                                {checkPermission(
                                                                                    "download_config"
                                                                                ) && (
                                                                                    <div
                                                                                        className="config-download tooltip-icon"
                                                                                        onClick={() => {
                                                                                            if (
                                                                                                config.auto_session_enabled ==
                                                                                                "auto"
                                                                                            ) {
                                                                                                this.downloadWithUpdateTime();
                                                                                                this.setState(
                                                                                                    {
                                                                                                        selectedConfig:
                                                                                                        config.id,
                                                                                                        selectedVersion:
                                                                                                        config.version
                                                                                                    }
                                                                                                );
                                                                                            } else {
                                                                                                this.download(
                                                                                                    config.id,
                                                                                                    config.version,
                                                                                                    undefined
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                    <span
                                                                                        className="tooltip-text">Download</span>
                                                                                        <i className="icon-arrow-to-bottom-light"/>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                            {checkPermission("import_config") && (
                                                                <button
                                                                    className="upload-configuration"
                                                                    onClick={
                                                                        this.triggerConfUpload
                                                                    }
                                                                >
                                                                    <i className="icon-arrow-to-top-light"/>
                                                                    Upload
                                                                </button>
                                                            )}

                                                            {checkPermission("create_configs") && (
                                                                <Link
                                                                    to={`/configurations/new/${this.props.inspectingHall.id}/${this.state.inspectingServer.id}`}
                                                                    className="add-configuration"
                                                                >
                                                                    <i className="icon-plus-light"/>
                                                                    New
                                                                </Link>
                                                            )}
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    )}
                                    <div className={"panel-container-license-history"}>
                                        {(
                                            this.state.inspectingServer && !this.state.inspectingServer.perpetual_license &&
                                            (checkPermission("upload_seed") ||
                                                checkPermission("download_license") ||
                                                checkPermission("manage_licensing") ||
                                                checkPermission("view_license"))) && (
                                            <React.Fragment>
                                                <div className="panel-container-licenses">
                                                    <h1>License process</h1>
                                                    <div>
                                                        <LicenseRequest
                                                            allow={
                                                                this.props
                                                                    .inspectingHall &&
                                                                this.props
                                                                    .inspectingHall
                                                                    .allow_license_renew ==
                                                                true
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )}
                                        {this.state.inspectingServer && !this.state.inspectingServer.perpetual_license &&
                                            checkPermission("licensing_history") && (
                                                <ActivityFeed
                                                    serverId={
                                                        this.props.match.params[
                                                            "serverId"
                                                            ]
                                                    }
                                                    maxHeight={this.state.inspectingServer.is_online ? "532px" : "385px"}
                                                />
                                            )}
                                    </div>
                                    {this.state.inspectingServer /*&& !this.props.inspectingServer.perpetual_license*/ &&
                                        checkPermission("spec_update") && (
                                            <SystemSpec
                                                serverId={
                                                    this.props.match.params["serverId"]
                                                }
                                                showDetail={this.showSpecDialog}
                                                perpetualLicense={this.state.inspectingServer.perpetual_license}
                                            />
                                        )}
                                    {this.state.inspectingServer /*&& !this.props.inspectingServer.perpetual_license*/ &&
                                        checkPermission("spec_history") && (
                                            <SystemSpecHistory
                                                serverId={
                                                    this.props.match.params["serverId"]
                                                }
                                                showDetail={this.showSpecDialog}
                                            />
                                        )}
                                    <Machines
                                        isOnline={Boolean(
                                            this.state.inspectingServer &&
                                                this.state.inspectingServer
                                                    .is_online
                                        )}
                                        machines={
                                            this.state.inspectingServer &&
                                            this.state.inspectingServer
                                                .current_data
                                                ? this.state.inspectingServer
                                                      .current_data.machines
                                                : []
                                        }
                                        onRefresh={this.refreshServer}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>}
                <div
                    className={`start-compare-banner ${
                        this.state.selectedForComparison.length > 0
                            ? "active"
                            : ""
                    }`}
                >
                    <div className="banner-container container">
                        {this.state.selectedForComparison.length == 0 && (
                            <p>
                                0 configuration selected. Please select at least
                                2 to compare.
                            </p>
                        )}
                        {this.state.selectedForComparison.length == 1 && (
                            <p>
                                1 configuration selected. Please select another
                                one.
                            </p>
                        )}
                        {this.state.selectedForComparison.length > 1 && (
                            <p>
                                {this.state.selectedForComparison.length}{" "}
                                configurations selected.{" "}
                                <button onClick={this.openCompareMode}>
                                    Click here to see the difference between
                                    them.
                                </button>
                            </p>
                        )}
                        <button onClick={this.deselectAllToCompare}>
                            Cancel
                        </button>
                    </div>
                </div>
                <Dialog
                    addedClassName="compare-dialog"
                    open={this.state.isCompareModeActive}
                    onClose={this.onCompareClose}
                >
                    {this.state.isCompareModeActive && (
                        <ConfigurationsCompare
                            onCompareClose={this.onCompareClose}
                            selectedForComparison={
                                this.state.selectedForComparison
                            }
                        />
                    )}
                </Dialog>
                <Dialog
                    open={this.state.specsDialog}
                    onConfirm={this.closeSpecDialog}
                    onClose={this.closeSpecDialog}
                    confirmLabel="Close Detail"
                    hideCancel={true}
                    addedClassName="spec-detail-dialog"
                >
                    <SystemSpecDetail specification={this.state.selectedSpec}/>
                </Dialog>

                {this.props.creationMode === CreationModes.UPLOAD_CONFIG && (
                    <Drawer
                        title="Upload Configuration"
                        onClose={this.closeConfUpload}
                    >
                        <UploadConfiguration
                            inspectingHall={this.props.inspectingHall}
                            inspectingServer={this.state.inspectingServer}
                        />
                    </Drawer>
                )}

                <Dialog
                    open={this.state.downloadDialog}
                    onConfirm={this.submitDownloadDialog}
                    onClose={this.closeDownloadDialog}
                    confirmLabel="Download Config"
                    validSubmit={this.state.selectedUpdateTimeValid}
                    addedClassName="download-session-time-dialog"
                >
                    <h3>Download Configuration with Auto Session</h3>
                    {/*<div className="info">
                        <b>Note:</b> This configuration has auto session
                        enabled; Please fill the update time info to
                        download this configuration.
                    </div>*/}
                    <div className="warning">
                        <b>Info:</b> Filling the update time does not update the
                        config version, even if downloaded with different Update
                        Times, the server will only accept this configuration
                        once.
                    </div>
                    <Form
                        key={`${this.state.downloadDialog.toString()}`}
                        fields={sessionTimeFormFields}
                        initialValues={{}}
                        onChange={formValues => {
                            this.setState({
                                selectedUpdateTime:
                                formValues.values.update_time,
                                selectedUpdateTimeValid: formValues.isValid
                            });
                        }}
                    />
                </Dialog>
                <Dialog
                    open={this.state.uploadRemotelyDialog}
                    onConfirm={() => this.openConfirmUploadRemotelyDialog()}
                    onClose={this.closeConfirmUploadRemotelyDialog}
                    confirmLabel="Continue"
                    validSubmit={this.state.selectedUpdateTimeValid}
                    addedClassName="download-session-time-dialog"
                >
                    <h3>Update Remotely Configuration with Auto Session</h3>
                    <div className="warning">
                        <b>Info:</b> Filling the update time does not update the
                        config version, even if downloaded with different Update
                        Times, the server will only accept this configuration
                        once.
                    </div>
                    <Form
                        fields={sessionTimeFormFields}
                        initialValues={{}}
                        onChange={formValues => {
                            this.setState({
                                selectedUpdateTime:
                                formValues.values.update_time,
                                selectedUpdateTimeValid: formValues.isValid
                            });
                        }}
                    />
                </Dialog>
                <Dialog
                    open={this.state.confirmUploadRemotelyDialog}
                    onConfirm={this.uploadRemotely}
                    onClose={this.closeConfirmUploadRemotelyDialog}
                    addedClassName={`spec-detail-dialog${
                        hasRemoteRTPProfiles
                            ? " remote-rtp-update-dialog"
                            : ""
                    }`}
                >
                    <p>
                        <b>
                            {supportsRemoteUpdateOptions
                                ? "Remote Update"
                                : "ATTENTION"}
                        </b>
                    </p>
                    <span>
                        {supportsRemoteUpdateOptions
                            ? supportsGameLogoUpdate
                                ? "Choose what to update"
                                : null
                            : "Are you sure you want to update the configuration of this server remotely?"}
                    </span>
                    {supportsRemoteUpdateOptions && (
                        <RemoteUpdateOptions
                            includeServerConfig={this.state.includeServerConfig}
                            includeGameLogos={this.state.includeGameLogos}
                            showServerConfig={supportsGameLogoUpdate}
                            showGameLogos={supportsGameLogoUpdate}
                            gameRTPProfiles={this.state.gameRTPProfiles}
                            onServerConfigChange={includeServerConfig =>
                                this.setState({includeServerConfig})
                            }
                            onGameLogosChange={includeGameLogos =>
                                this.setState({includeGameLogos})
                            }
                            onRTPProfileForceChange={(index, force) => {
                                const gameRTPProfiles = this.state.gameRTPProfiles.map(
                                    (profile, profileIndex) =>
                                        profileIndex === index
                                            ? {...profile, force}
                                            : profile
                                );
                                this.setState({gameRTPProfiles});
                            }}
                            onAllRTPProfilesForceChange={force =>
                                this.setState({
                                    gameRTPProfiles: this.state.gameRTPProfiles.map(
                                        profile => ({...profile, force})
                                    )
                                })
                            }
                        />
                    )}
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    inspectingHall: hallsStoreSelectors.inspectingHall(state),
    inspectingServer: hallsStoreSelectors.inspectingServer(state),
    inspectingServerConfigurationsList: hallsStoreSelectors.select(
        "inspectingServerConfigurationsList"
    )(state),
    inspectingServerConfigurationsListLoading: hallsStoreSelectors.select(
        "inspectingServerConfigurationsListLoading"
    )(state),
    creationMode: hallsStoreSelectors.creationMode(state),
    userInfo: homeStoreSelectors.userInfo()
});

const mapDispatchToProps = {
    getHall: HallsActionCreators.getHall,
    getConfigurationsList: HallsActionCreators.getConfigurationsList,
    getServer: HallsActionCreators.getServer,
    cleanInspectingServer: HallsActionCreators.cleanInspectingServer,
    updateCreationMode: HallsActionCreators.updateCreationMode,
    clearCompareConfigs: HallsActionCreators.clearCompareConfigs,
    getServerLicenseState: HallsActionCreators.getServerLicenseState,
    uploadConfigurationRemotely: HallsActionCreators.uploadConfigurationRemotely
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ServerPage));
